import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  currentOrgKey: '',
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    changeCurrentOrganization: (state, action: PayloadAction<string>) => {
      state.currentOrgKey = action.payload;
    },
  },
});

export const { changeCurrentOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;
